import React from 'react';

const SectionCard = ({ children, extraClass = '' }) => (
  <div className={`bg-white brd-10 shadow-small p-20 m-b-20 ${extraClass}`}>{children}</div>
);

const CardHeader = ({ title, action, onAction }) => (
  <div className="flex justspacebetween aligncenter m-b-15">
    <span className="fw700 font-15 color-black">{title}</span>
    {action && <span className="font-12 highlight pointer fw500" onClick={onAction}>{action}</span>}
  </div>
);

const ContactDetailsTab = ({orgRegistration}) => {
  const {data:regInfo={}} = orgRegistration;

  return (
    <SectionCard>
      <CardHeader title="Contact Details" action="Edit" />
      <div className="flex wrap gap-20">
        {[
          ['Primary Contact', regInfo.prim_contact], ['Email', regInfo.prim_email],
          ['Phone', regInfo.telephone],   ['Mobile', regInfo.prim_mobile],
          ['Address', regInfo.street_1], ['Chapter', `${regInfo.state}, ${regInfo.country}`],
        ].map(([k, v]) => (
          <div key={k} className="wid-30 m-b-15">
            <div className="font-11 fw700 lgrey text-upp ls-1 m-b-2">{k}</div>
            <div className="font-14 dark-navy fw500">{v}</div>
          </div>
        ))}
      </div>
    </SectionCard>
  );
};

export default ContactDetailsTab;